var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00391 16.4643C5.00391 17.3335 5.63471 17.9643 6.50391 17.9643H9.90391V16.9643H6.50391C6.18151 16.9643 6.00391 16.7867 6.00391 16.4643V3.46432C6.00422 3.33181 6.057 3.20482 6.1507 3.11112C6.2444 3.01742 6.3714 2.96464 6.50391 2.96432H9.90391V1.96432H6.50391C6.10621 1.96475 5.72493 2.12292 5.44371 2.40413C5.1625 2.68535 5.00433 3.06663 5.00391 3.46432V16.4643Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3635 13.4115L13.6443 12.7163L15.8212 10.4643H7.0039V9.46432H15.6287L13.6443 7.41152L14.3635 6.71632L17.5995 10.0639L14.3635 13.4115Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.71958f6d618127c2f5cf382d6c23778c.svg";
export { ForwardRef as ReactComponent };